<script>
import dialogMixin from './mixins/dialog'

export default {
  mixins: [dialogMixin],
  props: {
    dialogData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loadingGetProtection: false,
      ProtectionPageItem: null,
      domain: window.location.hostname,
      isMobileSize: false,
    }
  },
  mounted() {
    const initResizeListener = () => {
      window.addEventListener('resize', this.onMobileSize)
    }
    this.onMobileSize()
    initResizeListener()
  },
  destroyed() {
    const removeResizeListener = () => {
      window.removeEventListener('resize', this.onMobileSize)
    }
    removeResizeListener()
  },
  methods: {
    onMobileSize() {
      this.isMobileSize = document.body.clientWidth <= 767
    },
    openLock() {
      this.$store.dispatch('auth/setLock', false)
      this.dialogMixinDialogVisible = false
    },
  },
}
</script>
<template>
  <el-dialog :visible.sync="dialogMixinDialogVisible" :before-close="$DialogMixinOnClose" :custom-class="`${$style.dialogValid}`" width="876px" append-to-body :fullscreen="isMobileSize">
    <article class="article">
      <h3 class="mt-4 mb-3 text-center text-xl md:text-3xl font-regular">{{ dialogData.title }}</h3>
      <div class="mt-5 mb-5 text-center">
        <p class="mb-6">{{ dialogData.text1 }}</p>
        <p>{{ dialogData.email }}</p>
        <p>{{ dialogData.text2 }}</p>
      </div>
      <template v-if="dialogData.type === 1">
        <BaseButton class="isStylePrimary isRadius w-100" @click="openLock"> 確定 </BaseButton>
      </template>
      <template v-if="dialogData.type === 2">
        <BaseButton class="isStylePrimary isRadius w-100" @click="$emit('confirm')"> 確定 </BaseButton>
      </template>
      <template v-if="dialogData.type === 3">
        <BaseButton class="isStylePrimary isRadius w-100 mb-4" @click="$emit('nowLevelUp')"> 是，我要現在升級 </BaseButton>
        <BaseButton class="isStylePrimary isRadius isOutline2 w-100" @click="$emit('notNow')"> 否，現在不升級 </BaseButton>
      </template>
    </article>
  </el-dialog>
</template>
<style lang="scss" module>
.dialogValid {
  :global {
    .el-dialog__body {
      padding: 70px 50px !important;
    }
  }
}
</style>
